export var LineCap;
(function (LineCap) {
    /** 默认值。向线条的每个末端添加平直的边缘 */
    LineCap[LineCap["Butt"] = 0] = "Butt";
    /** 向线条的每个末端添加圆形线帽 */
    LineCap[LineCap["Round"] = 1] = "Round";
    /** 向线条的每个末端添加正方形线帽 */
    LineCap[LineCap["Square"] = 2] = "Square";
})(LineCap || (LineCap = {}));
export var LineJoin;
(function (LineJoin) {
    /** 创建圆角 */
    LineJoin[LineJoin["Round"] = 0] = "Round";
    /** 创建斜角 */
    LineJoin[LineJoin["Bevel"] = 1] = "Bevel";
    /** 创建尖角 */
    LineJoin[LineJoin["Miter"] = 2] = "Miter";
})(LineJoin || (LineJoin = {}));
